/* eslint-disable object-curly-newline,no-unused-expressions */
/* global G */

/**
 * Receives an attachment and initiates a download for it. This is useful for 'inline'
 * files we create in the business logic and want to download it without any other UI
 * element initiating it (so no group, gallery, download button, etc).
 *
 * @param {Gaia.Web.Application} app  the Web platform Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail: { [G.DATA]: detail } }) => {
  const { item } = detail

  try {
    if (!item?.value) {
      throw new ReferenceError(`Attachment not defined, got: ${JSON.stringify(item, null, 2)}`)
    }

    if (!item?.name && !item?.value?.name) {
      throw new ReferenceError(`Attachment name not defined, got: ${JSON.stringify(item, null, 2)}`)
    }

    const url = URL.createObjectURL(item.value)
    const link = document.createElement('a')
    link.href = url
    link.download = item.value?.name || item.name
    link.click()

    URL.revokeObjectURL(url)
    link.remove()
  } catch (e) {
    console.error(e)
  }
}

export default fn
